import React from 'react';
import { getMainTenantStatus } from '../tenantHelpers';

const normalizeClass = (value) =>
  String(value || 'unknown').toLowerCase().replace(/[^a-z0-9]+/g, '-');

const TenantStatusPill = ({ tenant, size = 'md', showDot = false }) => {
  const status = getMainTenantStatus(tenant);
  return (
    <span
      className={`stm-status-pill stm-status-pill--${normalizeClass(status)} stm-status-pill--${size}${showDot ? ' stm-status-pill--dot' : ''}`}
    >
      {showDot && <span className="stm-status-pill__dot" aria-hidden="true" />}
      {status}
    </span>
  );
};

export default TenantStatusPill;
